<template>
  <div class="base-margin__left-20">
    <div>
      <p>{{ $t('customCluster.activity.otherOperationsActivity.operation') }}</p>
      <p class="base-margin__bottom-5 base-margin__left-20">
        {{
          $t('customCluster.activity.otherOperationsActivity.plan', {
            action: filterActivity(detailsDataInfo.activityType),
            count: detailsDataInfo.eventResourceCount
          })
        }}
        <span v-if="detailsDataInfo.createBatchIndex">{{
            $t('customCluster.activity.otherOperationsActivity.batch', {index: detailsDataInfo.createBatchIndex})
          }}</span>
      </p>
    </div>
    <div v-if="detailsDataInfo.activityStatus !== SubclusterActivityStatusRunning">
      <p>{{ $t('customCluster.activity.otherOperationsActivity.result') }}</p>
      <div class="base-margin__left-20">
        <p v-if="detailsDataInfo.errorMessage === ''" class="base-margin__bottom-5">
          {{
            $t('customCluster.activity.otherOperationsActivity.success', {
              action: filterActivity(detailsDataInfo.activityType),
              count: detailsDataInfo.successNumber
            })
          }}
        </p>
        <p v-else class="base-margin__bottom-5 base-color__red">
          {{
            $t('customCluster.activity.otherOperationsActivity.partial', {
              action: filterActivity(detailsDataInfo.activityType),
              success: detailsDataInfo.successNumber,
              failed: detailsDataInfo.eventResourceCount - detailsDataInfo.successNumber
            })
          }}
        </p>
      </div>
    </div>
    <div v-if="detailsDataInfo.hostnameRangeList" class="base-margin__left-20">
      <div class="base-margin__bottom-5">
        {{
          $t('customCluster.activity.otherOperationsActivity.instances', {action: filterActivity(detailsDataInfo.activityType)})
        }}
        <p v-for="(item, index) in detailsDataInfo.hostnameRangeList" :key="index">
          <span v-if="item.count === 1">{{ item.startHost }} ({{ item.count }})</span>
          <span v-else>{{ item.startHost }} ~ {{ item.endHost }} ({{ item.count }})</span>
        </p>
      </div>
    </div>
    <div v-if="detailsDataInfo.errorMessage" class="base-margin__left-20">
      <p class="base-margin__bottom-5 base-color__red base-margin__left-20">
        {{
          $t('customCluster.activity.otherOperationsActivity.reason', {
            action: filterActivity(detailsDataInfo.activityType),
            errorMessage: detailsDataInfo.errorMessage
          })
        }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  SubclusterActivityStatusRunning,
  SubclusterActivityTypeRebootInstances,
  SubclusterActivityTypeRunInstances,
  SubclusterActivityTypeStartInstances,
  SubclusterActivityTypeStopInstances,
  SubclusterActivityTypeTerminateInstances,
} from '@/common/constants';

export default {
  name: 'otherOperationsActivity',
  props: {
    detailsData: Object,
  },
  data() {
    return {
      detailsDataInfo: {},
      SubclusterActivityStatusRunning
    };
  },

  mounted() {
    const successList = [];
    const errorList = [];
    this.detailsData.detailData.map((item) => {
      if (item.status === 3) {
        successList.push(item);
      }
      if (item.status === 4) {
        errorList.push(item);
      }
    });

    this.detailsDataInfo = {
      ...this.detailsData,
      successList,
      errorList,
      successNumber: successList.length,
      errorNumber: errorList.length
    };
  },

  methods: {
    filterActivity(activityId) {
      switch (activityId) {
        case SubclusterActivityTypeRunInstances:
          return this.$t('customCluster.activity.otherOperationsActivity.create');
        case SubclusterActivityTypeRebootInstances:
          return this.$t('customCluster.activity.otherOperationsActivity.reboot');
        case SubclusterActivityTypeStopInstances:
          return this.$t('customCluster.activity.otherOperationsActivity.stop');
        case SubclusterActivityTypeStartInstances:
          return this.$t('customCluster.activity.otherOperationsActivity.start');
        case SubclusterActivityTypeTerminateInstances:
          return this.$t('customCluster.activity.otherOperationsActivity.terminate');
      }
    },
  },
};
</script>
